export default __webpack_public_path__ + "static/media/google-play.4f85c200.svg";